
export default superclass => class extends superclass  {
    getPaletteValue(currentPalette) {
        if (currentPalette === undefined ||
            currentPalette === null) {
            return this.unlockedValue;
        }
        
        let v = this.paletteToValue[currentPalette];
        if (v === undefined) {
            return this.unlockedValue;
        }
        return v;
    }

    isPaletteLocked(checkSelect) {
        return this.getCurrentPalette(checkSelect) !== undefined;
    }

    getCurrentPalette(checkSelect=false) {
        if (!this.store || !this.context || !this.context.track ||
            !this.automatable) {
            return undefined;
        }

        if (checkSelect) {
            return this.store.getState().effects.selectedPalettes[this.context.track.id];
        }
        return this.store.getState().effects.sequencedPalettes[this.context.track.id];
    }
}
